import PATHS from "router/paths"
import {
  FoodResultsWrapper,
  FoodResultsHeader,
  CreateNewMealLink,
  FoodResultsTitle,
  FoodResultsBox,
  CreateNotFoundFoodLink,
} from "./styled"
import { FoodListDivider } from "components/foodItem/FoodListItem/styled"
import { DotLoading, InfiniteScroll } from "antd-mobile"
import { FlexBox } from "components/Common/FlexBox"
import { Fragment } from "react"
import NoFoodFound from "./NoFoodFound"
import PlusIconLight from "components/Icons/PlusIconLight"
import Highlighter from "react-highlight-words"
import { useLogBrazeEvent } from "libs/braze"
import { SearchFoodResultType } from "model/food/types"
import SearchableFoodItem from "components/foodItem/SearchFoodResultItem"

interface IProps<T extends SearchFoodResultType> {
  foods: T[]
  onLoad: () => any
  loading: boolean
  hasMore: boolean
  keyword: string
  hasCreateLink?: boolean
  onSelectFood?: (food: T) => void
  onAddFood?: (food: T) => void
  noSearchedFoodFounded: boolean
  noCreateLinkIfNoFoodFounded?: boolean
  hideAddBtn?: boolean
  headerStyle?: React.CSSProperties
  style?: React.CSSProperties
  contentRef?: React.RefObject<HTMLDivElement>
}
const SearchFoodResults = <T extends SearchFoodResultType>(
  props: IProps<T>,
) => {
  const {
    noSearchedFoodFounded,
    noCreateLinkIfNoFoodFounded,
    foods,
    onLoad,
    loading,
    hasMore,
    keyword,
    hasCreateLink,
    onSelectFood,
    onAddFood,
    hideAddBtn,
    headerStyle = {},
    contentRef,
  } = props

  const isFirstLoading = !foods.length && loading

  const { logBrazeManualInputStarted } = useLogBrazeEvent()

  return (
    <FoodResultsWrapper>
      {isFirstLoading ? (
        <FoodResultsHeader style={headerStyle}>
          <FoodResultsTitle>Searching...</FoodResultsTitle>
        </FoodResultsHeader>
      ) : noSearchedFoodFounded ? (
        <FlexBox
          $direction="column"
          $alignItems="center"
          $gap={14}
          style={{ padding: "0 var(--app-horizontal-padding)" }}
        >
          <NoFoodFound />
          {!noCreateLinkIfNoFoodFounded && (
            <CreateNotFoundFoodLink
              onClick={() => {
                logBrazeManualInputStarted()
              }}
              to={`${PATHS.app.food.create}?name=${keyword}`}
            >
              <PlusIconLight />
              <Highlighter
                highlightClassName="no-food-high-light-text"
                searchWords={keyword.split(" ")}
                autoEscape={true}
                textToHighlight={`Create "${keyword}" as a custom meal`}
              ></Highlighter>
            </CreateNotFoundFoodLink>
          )}
        </FlexBox>
      ) : (
        <Fragment>
          <FoodResultsHeader style={headerStyle}>
            <FoodResultsTitle>Results</FoodResultsTitle>
            {hasCreateLink && (
              <CreateNewMealLink
                to={PATHS.app.food.create}
                onClick={() => {
                  logBrazeManualInputStarted()
                }}
              >
                Create New Meal
              </CreateNewMealLink>
            )}
          </FoodResultsHeader>

          <FoodResultsBox ref={contentRef}>
            {foods.map((food, index) => {
              return (
                <div key={food.uuid}>
                  <SearchableFoodItem
                    food={food}
                    keyword={keyword}
                    onSelect={onSelectFood}
                    onAdd={onAddFood}
                    hideAddBtn={hideAddBtn}
                  />
                  {index !== foods.length - 1 && <FoodListDivider />}
                </div>
              )
            })}

            {loading && (
              <FlexBox
                style={{ height: 40, width: "100%" }}
                $justify="center"
                $alignItems="center"
              >
                {" "}
                <span>Loading more food</span>
                <DotLoading />
              </FlexBox>
            )}
            <InfiniteScroll loadMore={onLoad} hasMore={hasMore}>
              {!foods.length ? null : hasMore ? null : "All foods found"}
            </InfiniteScroll>
          </FoodResultsBox>
        </Fragment>
      )}
    </FoodResultsWrapper>
  )
}

export default SearchFoodResults
